/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $BiometricsProvider = {
  type: 'Enum',
} as const;
